import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const OwnerPrivateRoute = ({ children }) => {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const verify = async () => {
      const token = localStorage.getItem('owner_token');
      if (!token) { setStatus('unauthorized'); return; }
      try {
        await axios.get(`${API_BASE_URL}/owner/verify`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setStatus('authorized');
      } catch {
        localStorage.removeItem('owner_token');
        setStatus('unauthorized');
      }
    };
    verify();
  }, []);

  if (status === 'loading') {
    return <div className="flex items-center justify-center h-screen text-blue-700 text-xl">جاري التحقق...</div>;
  }

  return status === 'authorized' ? children : <Navigate to="/owner-login" />;
};

export default OwnerPrivateRoute;
